<template>
    <h2>Create event</h2>
</template>

<script>
    export default {
        name: "CreateEvent"
    }
</script>

<style scoped>

</style>